import React, { useState } from 'react';
import { string, node } from 'prop-types';
import classNames from 'classnames/bind';
import Cookies from 'universal-cookie';

import WarningPopin from 'components/WarningPopin';

import styles from './WithBlurPopin.module.scss';
const cx = classNames.bind(styles);

const cookies = new Cookies();

const WithBlurPopin = ({ children, className }) => {
  const [popinDisplay, setPopinDisplay] = useState(
    !cookies.get('taTermsAgreement') > 0
  );

  const hidePopin = () => {
    setPopinDisplay(false);
  };

  return (
    <div className={cx({ 'with-popin': popinDisplay }, className)}>
      <div className={cx('content')}>{children}</div>
      {popinDisplay && <WarningPopin hidePopin={hidePopin} />}
    </div>
  );
};

WithBlurPopin.propTypes = {
  className: string,
  children: node.isRequired,
};

WithBlurPopin.defaultProps = {
  className: null,
};

export default WithBlurPopin;



// WEBPACK FOOTER //
// ./src/containers/WithBlurPopin/WithBlurPopin.js